module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av0413-778c05f1db6519c4ebe5868c726d4e5f.jpg";